import { render, staticRenderFns } from "./SoCreate.vue?vue&type=template&id=53b74dde&scoped=true&"
import script from "./SoCreate.vue?vue&type=script&lang=js&"
export * from "./SoCreate.vue?vue&type=script&lang=js&"
import style0 from "./SoCreate.vue?vue&type=style&index=0&id=53b74dde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b74dde",
  null
  
)

export default component.exports